import { render } from "./insights.vue?vue&type=template&id=398ae258"
import script from "./insights.vue?vue&type=script&lang=js"
export * from "./insights.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__